<template>
  <div v-if="!sent">
    <FormulateForm
      name="requestPassword"
      v-model="formValues"
      @submit="requestPassword"
      class="mb-6"
    >
      <h1 class="font-bold text-3xl mb-8">
        Request password change
      </h1>

      <FormulateInput
        name="email"
        type="email"
        label="Email address"
        placeholder="Email address"
        validation="bail|required|email"
      />
      <FormulateErrors />
      <base-button type="submit" :loading="sending">
        Send request
      </base-button>
    </FormulateForm>

    <router-link
      to="/login"
      class="inline-block text-sm text-black border-b-2 border-transparent hover:border-blue-400"
    >
      Login
    </router-link>
  </div>
  <div v-else>
    <h1 class="text-green-400 font-bold text-3xl mb-4">
      Request sent!
    </h1>
    <p class="mb-2">
      Please check your mailbox, open the link attached within our message and
      follow further instructions.
    </p>
    <p>This page can now be closed.</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formValues: {},
      sending: false,
      sent: false,
    };
  },
  methods: {
    async requestPassword(data) {
      try {
        this.sending = true;
        await this.$api.post('/rest-auth/password/reset/', data);
        this.sent = true;
      } catch (error) {
        this.$formulate.handle(error, 'requestPassword');
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
